import React, { useEffect, useState } from "react";
import { Input, Typography, Button, Spin, Form, Select, notification } from "antd";
import { get, put } from "../../../api/axios";
import { Link, useNavigate } from "react-router-dom";
import { useParams } from "react-router";
import { ArrowLeftOutlined } from "@ant-design/icons";

const { Title } = Typography;

const EditAdmin = () => {
    const navigate = useNavigate();
    let { id } = useParams();

    const [fromLoading, setFromLoading] = useState(false);

    const [inputsValue, setInputsValue] = useState({});

    const [dataRoles, setDataRoles] = useState([]);

    const [optionRoles, setOptionRoles] = useState([]);

    useEffect(() => {
        get(`admins/${id}`).then((res) => {
            setInputsValue(res.data);
            setFromLoading(true);
        });
    }, [id]);

    const [loading, setLoading] = useState(false);

    const onFinish = (values) => {
        setLoading(true);

        put(`admins/${id}`, values)
            .then((res) => {
                notification.success({message: "edited successfully"});
                setLoading(false);
                navigate("/admins");
            })
            .catch((err) => {
                notification.error({
                    message: "Error!",
                    description: err.response.data.message,
                    duration: 5000
                });
                setLoading(false);
            });
    };

    useEffect(() => {
        setOptionRoles(
            dataRoles.map((d) => ({
                value: d.id,
                label: d.name,
            }))
        );
    }, [dataRoles]);

    useEffect(() => {
        get("get-all-roles").then((res) => {
            setDataRoles(res.data);
        });
    }, []);

    return (
        <div>
            <Title level={2} className="text-main mb-4">
                <Link className="text-dark me-3" to="/admins">
                    <ArrowLeftOutlined />
                    Edit Admin
                </Link>
            </Title>
            {fromLoading ? (
                <Form
                    className="wrapper-content"
                    onFinish={onFinish}
                    labelCol={{
                        span: 7,
                    }}
                    wrapperCol={{
                        span: 15,
                    }}
                    initialValues={{
                        name: inputsValue.name,
                        password: "",
                        role: inputsValue.role.id,
                    }}
                    autoComplete="off"
                >
                    <div className="row">
                        <div className="col-lg-12">
                            <Form.Item
                                label="Name"
                                name="name"
                                rules={[
                                    {
                                        required: true,
                                        message: "This field is required!",
                                    },
                                ]}
                            >
                                <Input />
                            </Form.Item>
                        </div>

                        <div className="col-lg-12">
                            <Form.Item label="Password" name="password">
                                <Input.Password />
                            </Form.Item>
                        </div>

                        <div className="col-lg-12">
                            <Form.Item label="role" name="role">
                                <Select
                                    showSearch
                                    allowClear
                                    optionFilterProp="children"
                                    className="w-100"
                                    filterOption={(input, option) =>
                                        (option?.label ?? "")
                                            .toLowerCase()
                                            .includes(input.toLowerCase())
                                    }
                                    placeholder="Select"
                                    options={optionRoles}
                                />
                            </Form.Item>
                        </div>

                        <div className="col-lg-4 offset-lg-4">
                            <Form.Item
                                wrapperCol={{
                                    offset: 1,
                                    span: 16,
                                }}
                            >
                                <Button
                                    loading={loading}
                                    size="large"
                                    block
                                    type="primary"
                                    htmlType="submit"
                                >
                                    {loading ? "Updating..." : "Update"}
                                </Button>
                            </Form.Item>
                        </div>
                    </div>
                </Form>
            ) : (
                <div className="text-center">
                    <Spin size="large" />
                </div>
            )}
        </div>
    );
};

export default EditAdmin;
